import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const partners = [
  { icon: 'ri-award-fill', name: 'MCS Certified', color: '#145A32' },
  { icon: 'ri-shield-check-fill', name: 'NAPIT Approved', color: '#145A32' },
  { icon: 'ri-car-fill', name: 'OZEV Authorised', color: '#145A32' },
  { icon: 'ri-star-fill', name: 'Which? Trusted', color: '#FFB800' },
  { icon: 'ri-building-2-fill', name: 'TrustMark', color: '#145A32' },
  { icon: 'ri-leaf-fill', name: 'MicrogenCertification', color: '#4CAF50' },
];

export default function TrustBar() {
  const { ref, visible } = useScrollAnimation();

  return (
    <section className="bg-white border-b border-gray-100 py-5 md:py-7">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <p className="text-center text-gray-400 text-xs font-semibold uppercase tracking-widest mb-5">
          Our Certifications &amp; Partners
        </p>
        <div
          ref={ref}
          className="grid grid-cols-2 sm:grid-cols-3 md:flex md:flex-wrap items-center justify-center gap-4 md:gap-10"
        >
          {partners.map((p, i) => (
            <div
              key={p.name}
              style={{ transitionDelay: `${i * 70}ms` }}
              className={`flex items-center gap-2 text-[#1F2933] justify-center md:justify-start transition-all duration-500 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
            >
              <div className="w-7 h-7 flex items-center justify-center">
                <i className={`${p.icon} text-xl`} style={{ color: p.color }} />
              </div>
              <span className="font-semibold text-sm whitespace-nowrap text-gray-700">{p.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
